import angular from 'angular';
import customerDropdownComponent from './customer-dropdown.component';

let customerDropdownModule = angular.module('customerDropdown', [])
  .component('customerDropdown', customerDropdownComponent);

export default customerDropdownModule;




// WEBPACK FOOTER //
// ./client/common/directives/customer-dropdown/customer-dropdown.js